<template>
	<div>
		<div v-for="(item,index) in list.taskDetail" :key="index">
			<p class="p-title">{{item.containerNo}} <span style="width:7px;display:inline-block;"></span> {{item.skuCode}}</p>
			<div class="item-info">
				<ul class="item-ul">
					<li class="item-li">
						<div class="item-left">
							<span>发货编码</span><span>{{item.sourceNo}}</span>
						</div>
						<div class="item-right">
							<span>SKU名称</span><span style="word-break: break-all;">{{item.productNameCN}}</span>
						</div>
					</li>
					<li class="item-li">
						<div class="item-left">
							<span>调入仓</span><span>{{item.warehouseName}}</span>
						</div>
						<div class="item-right">
							<span>品牌</span><span>{{item.brand}}</span>
						</div>
					</li>
					<li class="item-li">
						<div class="item-left">
							<span>是否带电</span><span>{{item.isElectricityText}}</span>
						</div>
						<div class="item-right">
							<span>是否退税</span><span>{{item.isReturnTaxText}}</span>
						</div>
					</li>
					<li class="item-li">
						<div class="item-left">
							<span>型号</span><span>{{item.model}}</span>
						</div>
						<div class="item-right">
							<span style="white-space: nowrap;padding-right: 15px;">shipmentid</span><span>{{item.shipmentID}}</span>
						</div>
					</li>
					<li class="item-li">
						<div class="item-left">
							<span>FNSKU</span><span style="word-break: break-all;">{{item.fnsku}}</span>
						</div>
						<div class="item-right">
							<span>供应商</span><span>{{item.supplierCode}}</span>
						</div>
					</li>
					<li class="item-li">
						<div class="item-left">
							<span></span><span></span>
						</div>
						<div class="item-right" style="white-space: nowrap;">
							<span>{{item.actualQty}}/{{item.quantity}}</span
							><span>(打包数/调拨数)</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		
		<!-- 常规 -->
		<div class="conventionalBox-info">
			<p class="p-title"><span style="color: red">*</span>常规箱信息</p>

			<div class="signInDetail-btnBox" v-for="(item,index) in info1" :key="index">
				<ul>
					<li>
                        <div class="btnBox-left">
                            <van-field
                                size="mini"
                                v-model="item.sku"
                                placeholder="请扫码SKU"
                                right-icon="scan"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
								@input="showPicker=true"
                                @click-right-icon="scanSku('info1',index)"
								@click-input="scanSkuClick('info1',index)"
                            />
                            <van-field
                                size="mini"
                                v-model="item.sourceNo"
                                placeholder="发货计划编码"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
								readonly
                                clearable
                            />
                        </div>
                        <div class="btnBox-right">
                            <van-field
                                size="mini"
                                v-model="item.inStockSKUCode"
                                placeholder="填写调入仓SKU"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
                            />
                        </div>
					</li>
					<li>
						<span>单箱数量</span>
						<input
							type="number"
							class="volume fl"
                            style="max-width:23%;"
							v-model="item.singleBoxQty"
							@input="inputStockSKUCodeChange(index)"
							@change="inputParseIntNumChange('info1',index,'singleBoxQty')"
						/>
						<span>X <span style="color:#a5081a;">箱数</span></span>
						<input
							type="number"
							class="volume fl"
                            style="max-width:23%;"
							v-model="item.boxCount"
							@change="inputBoxCodeChange(index)"
							@input="inputParseIntNumChange('info1',index,'boxCount')"
						/>
						<div style="position: relative;">
							<span style="margin-left:5%;">总数：</span>
							<span>{{Number(item.singleBoxQty)*Number(item.boxCount) || 0}}</span>
							<span class="red tips" style="left: -22px;" v-if="item.quantityOut">装箱数已超调拨数</span>
							<span class="red tips" style="left: -120px;" v-if="item.BoxNoOrBoxCount">箱号与箱数不符</span>
						</div>

					</li>
					<li>
						<span>长</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxLength"
							@input="inputLenChange('info1',index,'boxLength',2)"
							@change="inputNumChange('info1',index,'boxLength',2)"
							placeholder="输入长(cm)"
						/>
						<span>宽</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxWidth"
							@input="inputLenChange('info1',index,'boxWidth',2)"
							@change="inputNumChange('info1',index,'boxWidth',2)"
							placeholder="输入宽(cm)"
						/>
						<span>高</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxHeight"
							@input="inputLenChange('info1',index,'boxHeight',2)"
							@change="inputNumChange('info1',index,'boxHeight',2)"
							placeholder="输入高(cm)"
						/>
					</li>
					<li>
						<span>毛重</span>
						<input
							type="number"
							class="volume fl"
							style="max-width: 40%"
							v-model="item.boxWeight"
							@input="inputLenChange('info1',index,'boxWeight',2)"
							@change="inputNumChange('info1',index,'boxWeight',2)"
							placeholder="请输入毛重(kg)"
						/>
					</li>
					<li style="position: relative;">
						<span class="vm">箱号</span>
						<input
							type="number"
							class="volume fl vm"
							v-model="item.startBoxNo"
							@change="inputParseIntNumChange('info1',index,'startBoxNo')"
						/>
						~
						<input
							type="number"
							class="volume fl vm"
							v-model="item.endBoxNo"
							@change="inputParseIntNumChange('info1',index,'endBoxNo')"
						/>
						<span class="red tips" style="left: 90px;" v-if="item.boxNoRepet">{{item.startBoxNo}}~{{item.endBoxNo}}箱号重复</span>
                        <span class="delInfo" @click="del(1,index)">{{info1.length === 1 ? "清空":"删除"}}</span>
                        <span class="addInfo" @click="add(1)">添加</span>
					</li>
				</ul>
			</div>
		</div>
		
		<!-- 混箱 -->
		<div class="conventionalBox-info">
			<p class="p-title">混装箱信息</p>

			<div class="signInDetail-btnBox"  v-for="(item,index) in info3" :key="index">
				<ul>
                    <li v-for="(itemBD,indexBD) in item.boxDetail" :key="indexBD">
                        <div class="btnBox-left">
                            <van-field
                                size="mini"
                                v-model="itemBD.sku"
                                :placeholder="`请扫码SKU${indexBD+1}`"
                                right-icon="scan"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
								@input="showPicker=true"
                                @click-right-icon="scanSku('info3',index,'boxDetail',indexBD)"
								@click-input="scanSkuClick('info3',index,'boxDetail',indexBD)"
								@clear="clearSku(index,indexBD)"
                            />
                            <van-field
                                size="mini"
								type="digit"
                                v-model="itemBD.qty"
                                :placeholder="`SKU${indexBD+1}单箱数量`"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
								maxlength="10"
								@input="singleBoxQtyChange(indexBD,index)"
                            />
                        </div>
                        <div class="btnBox-right">
                            <van-field
                                size="mini"
                                v-model="itemBD.inStockSKUCode"
                                placeholder="填写调入仓SKU"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
								v-if="indexBD === 0"
                            />
                            <van-field
								style="opacity:0;"
								v-else
                            />
                            <van-field
                                size="mini"
                                v-model="itemBD.sourceNo"
                                :placeholder="`SKU${indexBD+1}发货计划编码`"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
								readonly
                                clearable
                            />
                        </div>
					</li>
					<li>
                        <!-- <span style="color:red;line-height:20px;" v-if="item.notMixing">不可混装！存在shipmentid，供应商不一致！</span> -->
					</li>
					<li>
                        <div class="add" @click="mixinsAdd(index)">+</div>
					</li>
					<li>
						<span>长</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxLength"
							@input="inputLenChange('info3',index,'boxLength',2)"
							@change="inputNumChange('info3',index,'boxLength',2)"
							placeholder="输入长(cm)"
						/>
						<span>宽</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxWidth"
							@input="inputLenChange('info3',index,'boxWidth',2)"
							@change="inputNumChange('info3',index,'boxWidth',2)"
							placeholder="输入宽(cm)"
						/>
						<span>高</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxHeight"
							@input="inputLenChange('info3',index,'boxHeight',2)"
							@change="inputNumChange('info3',index,'boxHeight',2)"
							placeholder="输入高(cm)"
						/>
					</li>
					<li>
						<span>毛重</span>
						<input
							type="number"
							class="volume fl"
							style="max-width: 40%"
							v-model="item.boxWeight"
							@input="inputLenChange('info3',index,'boxWeight',2)"
							@change="inputNumChange('info3',index,'boxWeight',2)"
							placeholder="请输入毛重(kg)"
						/>
					</li>
					<li style="position: relative;">
						<span>箱号</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.startBoxNo"
							@change="inputParseIntNumChange('info3',index,'startBoxNo')"
						/>
                        <span class="delInfo" @click="del(3,index)">{{info3.length === 1 ? "清空":"删除"}}</span>
                        <span class="addInfo" @click="add(3)">添加</span>
					</li>
				</ul>
			</div>
		</div>		
		
		<!-- 尾箱 -->
        <div class="conventionalBox-info">
			<p class="p-title">尾箱信息</p>

			<div class="signInDetail-btnBox" v-for="(item,index) in info2" :key="index">
				<ul>					
                    <li>
                        <div class="btnBox-left">
                            <van-field
                                size="mini"
                                v-model="item.sku"
                                placeholder="请扫码SKU"
                                right-icon="scan"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
								@input="showPicker=true"
                                @click-right-icon="scanSku('info2',index)"
								@click-input="scanSkuClick('info2',index)"
                            />
                        </div>
                        <div class="btnBox-right">
                            <van-field
                                size="mini"
                                v-model="item.inStockSKUCode"
                                placeholder="填写调入仓SKU"
                                :center="true"
                                :border="false"
                                clear-trigger="always"
                                clearable
                            />
                        </div>
					</li>
					<li>
						<span>单箱数量</span>
						<input
							type="number"
							class="volume fl"
							style="max-width: 32%;"
							v-model="item.singleBoxQty"
							@input="inputStockSKUCodeChange2(index)"
							@change="inputParseIntNumChange('info2',index,'singleBoxQty')"
						/>
					</li>
					<li>
						<span>长</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxLength"
							@input="inputLenChange('info2',index,'boxLength',2)"
							@change="inputNumChange('info2',index,'boxLength',2)"
							placeholder="输入长(cm)"
						/>
						<span>宽</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxWidth"
							@input="inputLenChange('info2',index,'boxWidth',2)"
							@change="inputNumChange('info2',index,'boxWidth',2)"
							placeholder="输入宽(cm)"
						/>
						<span>高</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.boxHeight"
							@input="inputLenChange('info2',index,'boxHeight',2)"
							@change="inputNumChange('info2',index,'boxHeight',2)"
							placeholder="输入高(cm)"
						/>
					</li>
					<li>
						<span>毛重</span>
						<input
							type="number"
							class="volume fl"
							style="max-width: 40%"
							v-model="item.boxWeight"
							@input="inputLenChange('info2',index,'boxWeight',2)"
							@change="inputNumChange('info2',index,'boxWeight',2)"
							placeholder="请输入毛重(kg)"
						/>
					</li>
					<li style="position: relative;">
						<span>箱号</span>
						<input
							type="number"
							class="volume fl"
							v-model="item.startBoxNo"
							@change="inputParseIntNumChange('info2',index,'startBoxNo')"
						/>
						<span class="red tips" style="left: 90px;" v-if="item.boxNoRepet">{{item.startBoxNo}}箱号重复</span>
                        <span class="delInfo" @click="del(2,index)">{{info2.length === 1 ? "清空":"删除"}}</span>
                        <span class="addInfo" @click="add(2)">添加</span>
					</li>
				</ul>
			</div>
		</div>
		
		<!-- 照片 -->
        <div class="photo">
			<p class="p-title"><span style="color: red">*</span>打包照片<span style="font-weight:400;">（最少两张）</span></p>

            <div class="sign-photo-cpntent">
                <div class="sign-photo-box">
                    <ul>
                        <li
                            class="sign-photo-item"
                            v-for="(item, index) in skuImg"
                            :key="index"
                        >
                            <span
                                class="delete-icon"
                                @click="deleteImg(index)"
                                >x</span
                            >
                            <!-- <van-icon name="photo" size="6em" color="#169bd5"/> -->
                            <img
                                :src="item"
                                class="sign-photo-item-img"
                                alt=""
                                @click="previewImage(item)"
                            />
                        </li>

                        <li class="sign-photo-btn">
                            <div class="photo">
                                <input
                                    class="img hidden"
                                    @change="changeImg()"
                                    type="file"
                                    name="cover"
                                    ref="inputer"
                                    accept="image/*"
                                    multiple
                                />
                                <p @click="chooseImage">
                                    <i class="el-icon-camera"></i>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="sign-photo-save">
                    <button class="submit-btn" @click="submit">保存</button>
                </div>
            </div>
        </div>

		<!-- SKU扫码下拉选项 -->
		<van-popup v-model="showPicker" round position="bottom" get-container="#app">
			<van-picker
				show-toolbar
				confirm-button-text="确认"
				cancel-button-text="取消"
				:columns="columns"
				@cancel="showPicker = false"
				@confirm="onConfirm"
                :item-height="30"
                :visible-item-count="5"
			/>
		</van-popup>
	</div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Toast, Empty, List, Loading, Checkbox, Tab, Tabs,SwipeCell, Col, Row,Button,Cell,Dialog,ImagePreview } from 'vant';
import { mixins } from "../../mobileMixins";
import { mapMutations } from 'vuex'
import { getBaleSkuDetail,getBaleContainerDetail,getBaleHasBoxNum,AddReadyTaskPackaging } from '@/api/mobile/bale_api.js';
import { BaseApiUrl } from '@/api/axios_config';
import axios from 'axios';
export default {
	data() {
		return {
			list: {},
			info1: [  // 常规
				{sku:'', sourceNo:'' , singleBoxQty:'' , boxCount:'' , boxLength:'' , boxWidth:'' , boxHeight:'' , boxWeight:'' , inStockSKUCode:'' , startBoxNo:'' , endBoxNo:''}
			],
			info2: [  // 尾箱
				{singleBoxQty:'',boxLength:'',boxWidth:'',boxHeight:'',boxWeight:'',inStockSKUCode:'',startBoxNo:''}
			],
			info3: [  // 混箱
				{boxLength:'',boxWidth:'',boxHeight:'',boxWeight:'',startBoxNo:'',boxDetail:[{sku:'',qty:'',inStockSKUCode:'',sourceNo:''},{sku:'',qty:'',inStockSKUCode:'',sourceNo:''}]}
			],
			skuImg:[],
			imgFiles:[],
			skuCode:'',
			itemName:{
				sku:'SKU',
				sourceNo:'发货编码',
				singleBoxQty:'单箱数量',
				qty:'单箱数量',
				boxCount:'箱数',
				boxLength:'长',
				boxWidth:'宽',
				boxHeight:'高',
				boxWeight:'毛重',
				inStockSKUCode:'调入仓SKU',
				startBoxNo:'开始箱号',
				endBoxNo:'结束箱号',
			},
			showPicker: false,
			columns: [],
			saveScanSkuName:'',
			isEdit: false,   // 是否编辑
			saveImgUrlArr: [],
			saveMaxNoArr: [],
			shippingPlanDetailIDs:[]
		}
	},	
    components: {
		[Icon.name]: Icon,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Toast.name]: Toast,
		[List.name]: List,
		[Empty.name]: Empty,
		[Loading.name]: Loading,
		[Checkbox.name]: Checkbox,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[SwipeCell.name]: SwipeCell,
		[Col.name]: Col,
		[Row.name]: Row,
		[Button.name]: Button,
		[Cell.name]: Cell,
    	[Dialog.Component.name]: Dialog.Component,
		[ImagePreview.name]: ImagePreview,
		[Field.name]: Field
	},
	mixins: [mixins],
    created(){
		this.init()
    },
	methods: {
		init() {
			this.getDetail()
		},

		onConfirm(val){
			let v = val.text.split('(')
			let sNo = v[1].split(')')[0]
			let shippingPlanDetailID = val.shippingPlanDetailID
			const s = this.saveScanSkuName.split('-')
			if(s[2]){ // 混箱
				let arr = []
				let arr1 = []
				let arr2 = []
				const mixing = this[s[0]][s[1]][s[2]]
				mixing.forEach((item,i)=>{
					item.shippingPlanDetailID && arr.push(item.shippingPlanDetailID)
					item.shipmentID && arr1.push(item.shipmentID)
					item.supplierCode && arr2.push(item.supplierCode)
				})
				if(arr.includes(shippingPlanDetailID) && this[s[0]][s[1]][s[2]][[s[3]]].shippingPlanDetailID != shippingPlanDetailID){
					Toast('当前混箱存在相同发货计划')
					return
				}
				// this[s[0]][s[1]].forEach((item,i)=>{
				// 	this.$set(this[s[0]][i],'notMixing',false)
				// })
				if(arr1.length && arr2.length){
					if(arr1.includes(val.shipmentID) && arr2.includes(val.supplierCode)){  // shipmentID和supplierCode是否一致
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'shippingPlanDetailID',shippingPlanDetailID)
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'sku',v[0])
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'sourceNo',sNo)
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'shipmentID',val.shipmentID)
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'supplierCode',val.supplierCode)
					}else{
						// this.$set(this[s[0]][s[1]],'notMixing',true)
						Toast('不可混装！存在shipmentid，供应商不一致！')
						return
					}
				}else{
					this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'shippingPlanDetailID',shippingPlanDetailID)
					this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'sku',v[0])
					this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'sourceNo',sNo)
					this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'shipmentID',val.shipmentID)
					this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'supplierCode',val.supplierCode)
				}
				
				if(this[s[0]][s[1]][s[2]][[s[3]]].qty){
					try {
						this.$set(this[s[0]][s[1]][s[2]][[s[3]]],'inStockSKUCode',`${v[0]}-${this[s[0]][s[1]][s[2]][[s[3]]].inStockSKUCode.split('-')[1]}`)
					} catch{}
				}
			}else{  // 整箱，尾箱
				this.$set(this[s[0]][s[1]],'sku',v[0])
				this.$set(this[s[0]][s[1]],'sourceNo',sNo)
				this.$set(this[s[0]][s[1]],'shippingPlanDetailID',shippingPlanDetailID)
				if(this[s[0]][s[1]].singleBoxQty){
					try {
						this.$set(this[s[0]][s[1]],'inStockSKUCode',`${v[0]}-${this[s[0]][s[1]].inStockSKUCode.split('-')[1]}`)
					} catch{}
				}
			}
			this.showPicker = false
		},

		add(type){
			let obj = {}
			if(type === 1){ // 整箱
				obj = {sku:'', inStockSKUCode:'' , sourceNo:'' , singleBoxQty:'' , boxCount:'' , boxLength:'' , boxWidth:'' , boxHeight:'' , boxWeight:'' , startBoxNo:'' , endBoxNo:''}
			}else if(type === 2){ // 尾箱
				obj = {sku:'',inStockSKUCode:'',singleBoxQty:'',boxLength:'',boxWidth:'',boxHeight:'',boxWeight:'',startBoxNo:''}
			}else{ // 混箱
				obj = {boxLength:'',boxWidth:'',boxHeight:'',boxWeight:'',startBoxNo:'',boxDetail:[{sku:'',singleBoxQty:'',inStockSKUCode:'',sourceNo:''},{sku:'',qty:'',inStockSKUCode:'',sourceNo:''}]}
			}
			this[`info${type}`].push(obj)
		},

		del(type,i){
			
            const that = this
			const len = that[`info${type}`].length
			const msg = len === 1 ? '清空':'删除'
            Dialog.confirm({
                title: msg,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
                message: `确认进行${msg}操作吗？`,
            })
            .then(() => {
				if(len === 1) {
					that[`info${type}`].splice(i,1)
					that.add(type)
					return
				};

				that[`info${type}`].splice(i,1)
            })
            .catch(() => {
            });
		},

		mixinsAdd(i){
			this.info3[i].boxDetail.push({sku:'',singleBoxQty:'',sourceNo:''})
		},

		getDetail(){
			const data = {}
			if(this.$route.query.shippingPlanDetailID){
				data.shippingPlanDetailIDS = this.$route.query.shippingPlanDetailID
				data.stockingTaskID = this.$route.query.stockingTaskID
				this.getForSKU(data)
			}
			if(this.$route.query.containerNo){
				data.containerNo = this.$route.query.containerNo
				this.getForContainer(data)
			}
		},

		// 根据SKU获取信息
		getForSKU(data){

			getBaleSkuDetail(data).then(res=>{
				if (res.status === 200 && res.success) {
					const { response } = res

					let flag = false
					if(response.wholeCase.length){
						this.info1 = response.wholeCase
						response.wholeCase.forEach(item=>{
							if(item.stockingBoxSumID){
								flag = true
							}
							if(item.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)){
								this.shippingPlanDetailIDs.push(item.shippingPlanDetailID)
							}
						})
					}
					
					if(response.theTrunk.length){
						response.theTrunk.forEach(item=>{
							item.triggerCount = 1
							if(item.stockingBoxSumID){
								flag = true
							}
							if(item.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)){
								this.shippingPlanDetailIDs.push(item.shippingPlanDetailID)
							}
						})
						this.info2 = response.theTrunk
					}
					
					if(response.mixingTank.length){
						response.mixingTank.forEach(item=>{
							item.boxDetail.forEach(item2=>{
								item2.triggerCount = 1
								if(item2.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item2.shippingPlanDetailID)){
									this.shippingPlanDetailIDs.push(item2.shippingPlanDetailID)
								}
							})
							if(item.stockingBoxSumID){
								flag = true
							}
						})
						this.info3 = response.mixingTank
					}

					// 判断是否编辑
					if(flag){
						this.isEdit = true
					}

					if(response.urlPath && response.urlPath.length){
						response.urlPath.forEach((item,i)=>{
							response.urlPath[i] = `data:image/jpg;base64,${response.urlPath[i]}`
						})

						this.skuImg = response.urlPath
					}

					
					this.saveImgUrlArr = response.imgUrlList || []

					let arr = []
					response.taskDetail.forEach(item=>{
						arr.push({text:`${item.skuCode}(${item.sourceNo})`,shippingPlanDetailID:item.shippingPlanDetailID,supplierCode:item.supplierCode,shipmentID:item.shipmentID})
					})
					this.columns = arr
					
					this.list = response
				} else {
					Toast.fail(res.msg);
				}
			})
		},

		// 根据货柜号获取信息
		getForContainer(data){

			getBaleContainerDetail(data).then(res=>{
				if (res.status === 200 && res.success) {
					const { response } = res

					let flag = false
					if(response.wholeCase.length){
						this.info1 = response.wholeCase
						response.wholeCase.forEach(item=>{
							if(item.stockingBoxSumID){
								flag = true
							}
							if(item.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)){
								this.shippingPlanDetailIDs.push(item.shippingPlanDetailID)
							}
						})
					}
					
					if(response.theTrunk.length){
						response.theTrunk.forEach(item=>{
							item.triggerCount = 1
							if(item.stockingBoxSumID){
								flag = true
							}
							if(item.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item.shippingPlanDetailID)){
								this.shippingPlanDetailIDs.push(item.shippingPlanDetailID)
							}
						})
						this.info2 = response.theTrunk
					}

					if(response.mixingTank.length){
						response.mixingTank.forEach(item=>{
							item.boxDetail.forEach(item2=>{
								item2.triggerCount = 1
								if(item2.shippingPlanDetailID && !this.shippingPlanDetailIDs.includes(item2.shippingPlanDetailID)){
									this.shippingPlanDetailIDs.push(item2.shippingPlanDetailID)
								}
							})
							if(item.stockingBoxSumID){
								flag = true
							}
						})
						this.info3 = response.mixingTank
					}

					// 判断是否编辑
					if(flag){
						this.isEdit = true
					}
							
					if(response.urlPath && response.urlPath.length){
						response.urlPath.forEach((item,i)=>{
							response.urlPath[i] = `data:image/jpg;base64,${response.urlPath[i]}`
						})

						this.skuImg = response.urlPath
					}
					
					this.saveImgUrlArr = response.imgUrlList || []

					let arr = []
					response.taskDetail.forEach(item=>{
						arr.push({text:`${item.skuCode}(${item.sourceNo})`,shippingPlanDetailID:item.shippingPlanDetailID,supplierCode:item.supplierCode,shipmentID:item.shipmentID})
					})
					this.columns = arr

					this.list = response
				} else {
					Toast.fail(res.msg);
				}
			})
		},
		
		// 处理整箱的单箱数量
		inputStockSKUCodeChange(i){
			if(this.info1[i].singleBoxQty.length>10) this.$set(this.info1[i],'singleBoxQty',this.info1[i].singleBoxQty.slice(0,10))

			if(!this.info1[i].sku){
				Toast('请先选择SKU')
				this.$set(this.info1[i],'singleBoxQty','')
				return
			}

			this.$set(this.info1[i],'inStockSKUCode',this.info1[i].singleBoxQty ? `${this.info1[i].sku}-N${this.info1[i].singleBoxQty}`:'')
		},

		// 处理混箱的单箱数量和箱号
		singleBoxQtyChange(i,i2){

			if(i === 0){
				this.$set(this.info3[i2].boxDetail[i],'inStockSKUCode',this.info3[i2].boxDetail[i].qty?`${this.info3[i2].boxDetail[i].sku}-N${this.info3[i2].boxDetail[i].qty}`:'')
			}

			// 统计函数触发次数
			this.info3[i2].boxDetail[i].triggerCount++
			
			if(this.isEdit) {
				let n = this.saveMaxNoArr.length ? Math.max(...this.saveMaxNoArr) : this.list.cartonNo
				if(n === this.info3[i2].startBoxNo){  // 处于一行重复编辑中
					this.$set(this.info3[i2],'startBoxNo',this.info3[i2].startBoxNo)
					this.saveMaxNoArr.push(this.info3[i2].startBoxNo)
				}else{
					if(this.info3[i2].boxDetail[i].triggerCount <= 2){  // 处于页面刚加载中
						this.$set(this.info3[i2],'startBoxNo',this.info3[i2].startBoxNo)
					}else{
						this.$set(this.info3[i2],'startBoxNo',n+1)
						this.saveMaxNoArr.push(n+1)
					}
				}
				return
			}

			// 拿到info1的所有end箱号 
			let info1EndBoxNoArr = []
			for (let n=0; n < this.info1.length; n++) {
				if(this.info1[n].boxCount){
					info1EndBoxNoArr.push(this.info1[n].endBoxNo)
				}
			}

			let info1MaxBoxNo = info1EndBoxNoArr.length ? Math.max(...info1EndBoxNoArr) : this.list.cartonNo
			let arr = []
			// 遍历混箱，qty存在则赋值startBoxNo
			for (let m=0; m < this.info3.length; m++) {
				let flag1 = false
				this.info3[m].boxDetail.forEach(item=>{
					if(item.qty){
						flag1 = true
					}
				})
				if(flag1){
					let num = arr.length ? arr[arr.length-1]+1:(info1MaxBoxNo)+1
					this.$set(this.info3[m],'startBoxNo',Number(num))
					arr.push(num)
				}
			}
			
			// 该项singleBoxQty没值就清空
			let flag2 = false
			this.info3[i2].boxDetail.forEach(item=>{
				if(item.qty){
					flag2 = true
				}
			})
			
			if(!flag2){
				this.$set(this.info3[i2],'startBoxNo','')
			}

			
			this.inputStockSKUCodeChange2(0)
		},
		
		// 处理尾箱的单箱数量和箱号
		inputStockSKUCodeChange2(i){

			const that = this
			if(this.info2[i].singleBoxQty.length>10) this.$set(this.info2[i],'singleBoxQty',this.info2[i].singleBoxQty.slice(0,10))

			this.$set(this.info2[i],'inStockSKUCode',this.info2[i].singleBoxQty ? `${this.info2[i].sku}-N${this.info2[i].singleBoxQty}`:'')

			// function fn(){
			// 	const len = that.info1.length
			// 	for(var i=len;i--;){
			// 		if(that.info1[i].boxCount) return that.info1[i].endBoxNo
			// 	}
			// }

			// 拿到info1和info3 的所有end箱号 
			let info1EndBoxNoArr = []
			for (let n=0; n < this.info1.length; n++) {
				if(this.info1[n].boxCount){
					info1EndBoxNoArr.push(this.info1[n].endBoxNo)
				}
			}
			for (let n=0; n < this.info3.length; n++) {
				if(this.info3[n].startBoxNo){
					info1EndBoxNoArr.push(this.info3[n].startBoxNo)
				}
			}

			let info1MaxBoxNo = info1EndBoxNoArr.length ? Math.max(...info1EndBoxNoArr) : this.list.cartonNo
			let arr = []
			
			// 统计函数触发次数
			this.info2[i].triggerCount++

			if(this.isEdit) {
				let n = this.saveMaxNoArr.length ? Math.max(...this.saveMaxNoArr) : this.list.cartonNo
				if(n === this.info2[i].startBoxNo){  // 处于一行重复编辑中
					this.$set(this.info2[i],'startBoxNo',this.info2[i].startBoxNo)
					this.saveMaxNoArr.push(this.info2[i].startBoxNo)
				}else{
					if(this.info2[i].triggerCount <= 2){ 
						this.$set(this.info2[i],'startBoxNo',this.info2[i].startBoxNo)
					}else{
						this.$set(this.info2[i],'startBoxNo',n+1)
						this.saveMaxNoArr.push(n+1)
					}
				}
				return
			}
		
			for (let m=0; m < this.info2.length; m++) {
				if(this.info2[m].singleBoxQty){
					let num = arr.length ? arr[arr.length-1]+1:(info1MaxBoxNo)+1
					this.$set(this.info2[m],'startBoxNo',Number(num))
					arr.push(num)
				}
			}
			
			if(!this.info2[i].singleBoxQty){
				this.$set(this.info2[i],'startBoxNo','')
			}
		},

		// 处理整箱的箱号
		inputBoxCodeChange(i){

			let arr = []


			if(!this.info1[i].boxCount){
				this.$set(this.info1[i],'startBoxNo','')
				this.$set(this.info1[i],'endBoxNo','')
			}

			if(this.isEdit) {
				let n = this.saveMaxNoArr.length ? Math.max(...this.saveMaxNoArr) : this.list.cartonNo
				if(n === this.info1[i].endBoxNo){  // 处于一行重复编辑中
					this.$set(this.info1[i],'startBoxNo',this.info1[i].startBoxNo)
					this.$set(this.info1[i],'endBoxNo',Number(this.info1[i].startBoxNo)-1+Number(this.info1[i].boxCount))
					this.saveMaxNoArr = [Number(this.info1[i].startBoxNo)-1+Number(this.info1[i].boxCount)]
				}else{
					this.$set(this.info1[i],'startBoxNo',n+1)
					this.$set(this.info1[i],'endBoxNo',Number(n)+Number(this.info1[i].boxCount))
					this.saveMaxNoArr.push(Number(n)+Number(this.info1[i].boxCount))
				}
				return
			}else{
				this.$set(this.info1[i],'startBoxNo',this.list.cartonNo+1)
				this.$set(this.info1[i],'endBoxNo',Number(this.list.cartonNo)+Number(this.info1[i].boxCount))
			}
			
			arr.push(this.info1[0].endBoxNo)
			for (let m=1; m < this.info1.length; m++) {
				if(this.info1[m].boxCount){
					this.$set(this.info1[m],'startBoxNo',Number(arr[arr.length-1])+1)
					this.$set(this.info1[m],'endBoxNo',Number(arr[arr.length-1])+Number(this.info1[m].boxCount))

					arr.push(this.info1[m].endBoxNo)
				}
			}

			if(!this.info1[i].boxCount){
				this.$set(this.info1[i],'startBoxNo','')
				this.$set(this.info1[i],'endBoxNo','')
			}
			
			this.singleBoxQtyChange(0,0)
			this.inputStockSKUCodeChange2(0)
		},

		// 接口验证箱号是否重复
		getBaleHasBoxNums(){
			const {containerNo} = this.list.taskDetail[0]

			let endBoxNo

			let flag1 = false
			this.info2.forEach(item=>{
				if(item.singleBoxQty) flag1 = true
			})

			let flag2 = false
			this.info2.forEach(item=>{
				if(item.singleBoxQty) flag2 = true
			})

			let flag3 = false
			this.info3.forEach(item=>{
				item.boxDetail.forEach(item=>{
					if(item.singleBoxQty){
						flag3 = true
					}
				})
			})

			if(this.info2.length && flag1 && this.info1.length && flag2 && this.info3.length && flag3){
				let arr = []
				this.info2.forEach(item=>{
					arr.push(item.endBoxNo)
				})

				endBoxNo = Math.max(...arr)
			}

			this.info1.forEach(item => {
				if(item.boxCount){
					endBoxNo = 1
				}
			});

			const data = {
				containerNo,
				startBoxNo:1,
				endBoxNo,
			}
			getBaleHasBoxNum(data).then(res=>{

			})
		},

		// 前端验证打包数是否大于调拨数
		checkActualQty(){
			const that = this
			let arr = []
			for (let i = 0; i < this.info1.length; i++) {
				arr.push(Number(this.info1[i].singleBoxQty)*Number(this.info1[i].boxCount))
			}
			
			for (let j = 0; j < this.info2.length; j++) {
				arr.push(Number(this.info2[j].singleBoxQty))
			}			
			
			for (let k = 0; k < this.info3.length; k++) {
				this.info3[k].boxDetail.forEach(item=>{
					arr.push(Number(item.singleBoxQty))
				})
			}

			var sum = arr.reduce(function(prev,cur){
				return prev + cur
			})

			function reset(bool){
				that.info1.forEach((item,i)=>{
					that.$set(that.info1[i],'quantityOut',bool)
				})
				that.info2.forEach((item,i)=>{
					that.$set(that.info2[i],'quantityOut',bool)
				})
				that.info3.forEach((item,i)=>{
					that.$set(that.info3[i],'quantityOut',bool)
				})
			}

			reset(false)

			if(sum > this.list.taskDetail[0].quantity){
				reset(true)
				return true
			}
			return false
		},

		// 前端验证箱号是否和箱数相符
		checkBoxNoOrBoxCount(){
			let flag = false
			for (let i = 0; i < this.info1.length; i++) {
				const {startBoxNo,endBoxNo,boxCount} = this.info1[i]
				
				// 先重置BoxNoOrBoxCount
				if(this.info1[i].BoxNoOrBoxCount){
					this.$set(this.info1[i],'BoxNoOrBoxCount',false)
				}
				
				if(boxCount && Number(endBoxNo)-Number(startBoxNo)+1 !== Number(boxCount)){
					this.$set(this.info1[i],'BoxNoOrBoxCount',true)
					Toast('箱号与箱数不符')
					flag = true
				}
			}

			return flag

			// for (let i = 0; i < this.info2.length; i++) {
			// 	const {startBoxNo,endBoxNo,boxCount} = this.info2[i]
			// 	if(Number(endBoxNo)-Number(startBoxNo) !== Number(boxCount)){
			// 		return Toast('箱号与箱数不符')
			// 	}
			// }
		},

		// 前端验证箱号是否重复
		boxNoIsRepet(){
			let arr1 = [],arr2 = [],arr3 = []
			this.info1.forEach((item,i) => {
				if(item.boxCount){
					arr1.push(`${item.startBoxNo}-${item.endBoxNo}-1-${i}`)
				}
				
				// 重置重复字段
				if(item.boxNoRepet){
					this.$set(this.info1[i],'boxNoRepet',false)
				}
			});

			this.info2.forEach((item,i) => {
				if(item.singleBoxQty){
					arr2.push(`${item.startBoxNo}-${item.startBoxNo}-2-${i}`)
				}	

				// 重置重复字段		
				if(item.boxNoRepet){
					this.$set(this.info2[i],'boxNoRepet',false)
				}
			});			
			
			this.info3.forEach((item,i) => {
				if(item.startBoxNo){
					arr3.push(`${item.startBoxNo}-${item.startBoxNo}-2-${i}`)
				}	

				// 重置重复字段		
				if(item.boxNoRepet){
					this.$set(this.info2[i],'boxNoRepet',false)
				}
			});

			arr1.concat(arr2,arr3)
			let flag = false
			for (let i = 0; i < arr1.length; i++) {
				let ar1 = arr1[i].split('-')
				for (let j = ar1[0]; j < Number(ar1[1]) + 1; j++) {
					// 每一个数字和数组内的其它元素的遍历值进行判断是否相同
					for (let m = 0; m < arr1.length; m++) {
						if (m === i) continue;

						let ar2 = arr1[m].split('-')
						for (let k = Number(ar2[0]); k < Number(ar2[1]) + 1; k++) {
							if (Number(j) === Number(k)) { // 存在重复值
								// console.log('存在重复值-info',ar1[2],'-第',ar1[3]+'列')
								this.$set(this[`info${ar1[2]}`][ar1[3]],'boxNoRepet',true) 
								flag = true
							}
						}
					}
				}
			}

			return flag
		},

		// 检测是否写完全部信息
		checkAllInfo(){
			const arr1 = ['sku','sourceNo','singleBoxQty','boxCount','boxLength','boxWidth','boxHeight','boxWeight','inStockSKUCode','startBoxNo','endBoxNo']
			const arr2 = ['singleBoxQty','boxLength','boxWidth','boxHeight','boxWeight','inStockSKUCode','startBoxNo']
			const arr3 = ['sku','sourceNo','boxLength','boxWidth','boxHeight','boxWeight','qty','startBoxNo','inStockSKUCode']

			for (let i = 0; i < this.info1.length; i++) {
				const {sku , sourceNo , singleBoxQty , boxCount , boxLength , boxWidth , boxHeight , boxWeight , inStockSKUCode , startBoxNo , endBoxNo} = this.info1[i]
				if(sku || sourceNo || singleBoxQty || boxCount || boxLength || boxWidth || boxHeight || boxWeight || inStockSKUCode || startBoxNo || endBoxNo){
					for (const key in this.info1[i]) {
						if(arr1.includes(key)){
							if(!this.info1[i][key] || this.info1[i][key] === '0.00'){
								Toast(`请输入整箱${this.itemName[key]}`)
								return false
							}
						}
					}
				}
				
			}


			// 尾箱一个输入框有值，其它的都必填
			for (let i = 0; i < this.info2.length; i++) {
				const {singleBoxQty,boxLength,boxWidth,boxHeight,boxWeight,inStockSKUCode,startBoxNo} = this.info2[i]
				if(singleBoxQty || boxLength || boxWidth || boxHeight || boxWeight || inStockSKUCode || startBoxNo){
					for (const key in this.info2[i]) {
						if(arr2.includes(key)){
							if(!this.info2[i][key] || this.info2[i][key] === '0.00'){
								Toast(`请输入尾箱${this.itemName[key]}`)
								return false
							}
						}
					}
				}
			}

			// 混箱一个输入框有值，其它的都必填
			this.info3.forEach((item,i)=>{
				delete this.info3[i].sku
				delete this.info3[i].sourceNo
				delete this.info3[i].singleBoxQty
				delete this.info3[i].inStockSKUCode
			})
			for (let i = 0; i < this.info3.length; i++) {
				const {boxLength,boxWidth,boxHeight,boxWeight,startBoxNo,boxDetail} = this.info3[i]
				const {sku,sourceNo,qty,inStockSKUCode} = boxDetail
				if(sku || sourceNo || qty || boxLength || boxWidth || boxHeight || boxWeight || inStockSKUCode || startBoxNo){
					for (const key in this.info3[i]) {
						if(key == "boxDetail"){
							for (let l = 0; l < this.info3[i].boxDetail.length; l++) {
								const ss = this.info3[i].boxDetail[l]
								for (const key2 in ss) {
									if(arr3.includes(key2)){
										if(!ss[key2] || ss[key2] === '0.00'){
											if(l>0 && key2 === 'inStockSKUCode'){
											}else{
												Toast(`请输入混箱${this.itemName[key2]}`)
												return false
											}
										}
									}
								}
							}
						}else{
							if(arr3.includes(key) && key != 'boxDetail'){
								if(!this.info3[i][key] || this.info3[i][key] === '0.00'){
									Toast(`请输入混箱${this.itemName[key]}`)
									return false
								}
							}
						}
					}
				}
			}
			return true
		},

		// 检测填写的SKU是否存在
		checkSku(data){
			let arr = []
			this.list.taskDetail.forEach((item,i)=>{
				arr.push(item.skuCode)
			})
			for (let i = 0; i < data.length; i++) {
				if(data[i].boxType != 2){
					if(!arr.includes(data[i].sku)){
						return false
					}
				}else{
					for (let j = 0; j < data[i].boxDetail.length; j++) {
						if(!arr.includes(data[i].boxDetail[j].sku)){
							return false
						}
					}
				}
			}
			return true
		},

		// 提交
		submit(){
			const that = this

			if(!this.checkAllInfo()) return;

			if(this.saveImgUrlArr.length < 2) return Toast('最少两张照片')
			
			const data = [],saveIDS = []
			// 整箱
			this.info1.forEach((item,i)=>{
				if(item.boxCount){
					item.boxType = 1
					item.stockingBoxSumID = item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID
					item.stockingTaskID = item.stockingTaskID || this.list.taskDetail[0].stockingTaskID
					item.stockingBoxListID = item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID
					data.push(item)
					if(item.shippingPlanDetailID && !saveIDS.includes(item.shippingPlanDetailID)){
						saveIDS.push(item.shippingPlanDetailID)
					}
				}
			})

			// 尾箱
			this.info2.forEach((item,i)=>{
				if(item.startBoxNo){
					item.boxType = 3
					item.boxCount = 1
					item.endBoxNo = item.startBoxNo
					item.stockingBoxSumID = item.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID
					item.stockingTaskID = item.stockingTaskID || this.list.taskDetail[0].stockingTaskID
					item.stockingBoxListID = item.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID
					data.push(item)
					if(item.shippingPlanDetailID && !saveIDS.includes(item.shippingPlanDetailID)){
						saveIDS.push(item.shippingPlanDetailID)
					}
				}
			})

			// 混箱
			this.info3.forEach((item,i)=>{
				let obj = item
				if(obj.startBoxNo){
					obj.boxType = 2
					obj.boxCount = 1
					obj.endBoxNo = obj.startBoxNo
					obj.inStockSKUCode = obj.boxDetail[0].inStockSKUCode
					obj.stockingBoxSumID = obj.stockingBoxSumID || this.list.taskDetail[0].stockingBoxSumID
					obj.stockingTaskID = obj.stockingTaskID || this.list.taskDetail[0].stockingTaskID
					obj.stockingBoxListID = obj.stockingBoxListID || this.list.taskDetail[0].stockingBoxListID

					obj.boxDetail.forEach((item2,i2)=>{
						delete obj.boxDetail[i2].shipmentID
						delete obj.boxDetail[i2].supplierCode
						delete obj.boxDetail[i2].triggerCount
						if(item2.shippingPlanDetailID && !saveIDS.includes(item2.shippingPlanDetailID)){
							saveIDS.push(item2.shippingPlanDetailID)
						}
					})
					data.push(item)
				}
			})

			if(data.length){
				if(!this.isEdit){
					if(this.boxNoIsRepet()) return Toast('箱号重复')
				}

				if(this.checkBoxNoOrBoxCount() ) return Toast('箱号与箱数不符')

				if(this.checkActualQty()) return Toast('装箱数已超调拨数')

				if(!this.checkSku(data)) return Toast('存在非当前发货计划的SKU,请检查后再提交')
			}else{
				return Toast('请至少输入一种类型')
			}

			let info3DetailFlag = false

			let data2 = JSON.parse(JSON.stringify(data))

			data2.forEach((item,i)=>{
				delete data2[i].quantityOut
				delete data2[i].BoxNoOrBoxCount
				delete data2[i].boxNoRepet
				delete data2[i].triggerCount

				if(item.boxType === 2){
					if(item.boxDetail.length < 2){
						info3DetailFlag = true
					}
					item.boxDetail.forEach((item2,i2)=>{
						delete item2.inStockSKUCode
					})
				}
			})

			if(info3DetailFlag) return Toast('请输入完整混箱信息')

			let ids = Array.from(new Set(saveIDS.concat(this.shippingPlanDetailIDs)))
			const obj = {
				boxList : data2,
				file : this.saveImgUrlArr,
				shippingPlanDetailIDs: ids.toString() || ''
			}

			Toast.loading({
				message: '打包中...',
				forbidClick: true,
				overlay:true,
				duration:0
			});

			console.log('obj',obj)
			AddReadyTaskPackaging(obj).then(res=>{
				Toast.clear()
				if(res.status === 200 && res.success){
					Toast.success(res.msg||'打包成功')

					setTimeout(function(){
                        that.$router.go(-1)
                    },1500)
				}else{
					Toast.fail(res.msg)
				}
			})

		},

        scanSku(m,i,n,i2){
            let that = this
            this.$wx.scanQRCode({
                needResult: 1,
                desc: 'scanQRCode desc',
                success: function (a) {
					let flag = false
					that.columns.forEach(item=>{
						const t = item.text.split('(')[0]
						if(t === a.resultStr){
							flag = true  // 存在sku
						}
					})

					if(!flag){
						Toast('请扫描属于当前计划的SKU')
					}else{
						that.showPicker = true
						that.saveScanSkuName = `${m}-${i}`+(n?`-${n}`:'')+(i2 != null?`-${i2}`:'')
						if(n){
							that.$set(that[m][i][n][i2],'sku',a.resultStr)
						}else{
							that.$set(that[m][i],'sku',a.resultStr)
						}
					}
                }
            })
        },

		scanSkuClick(m,i,n,i2){
			this.saveScanSkuName = `${m}-${i}`+(n?`-${n}`:'')+(i2 != null?`-${i2}`:'')
			this.showPicker = !this.showPicker
		},

		deleteImg(i) { 
			this.skuImg.splice(i,1)
			// this.imgFiles.splice(i,1)
			this.saveImgUrlArr.splice(i,1)
		},

		changeImg() {
			const img = document.getElementsByClassName('img')[0]
			let imgList = [...img.files]

			this.imgFiles.push(...imgList)

			this.handleFiles(imgList)

			this.submitImg()
		},

		chooseImage() {
			document.getElementsByClassName('img')[0].click()
		},

		// 预览图片
		previewImage(url) {
			ImagePreview({
				images: [url],
				closeable: true,
			});
		},

		handleFiles(files) {
			const that = this
			let srcArr = []   // 保存转换的base64 imgFileUrl 

			for (var i = 0; i < files.length; i++) {
				var file = files[i];

				const { type, name } = file

				var imageType = /^image\//;
				if (!imageType.test(type)) {
					continue;
				}

				var reader = new FileReader();
				reader.onload = function (e) {
					that.$set(that.skuImg,that.skuImg.length,e.target.result)
				};
				reader.readAsDataURL(file);
			}
		},

		submitImg(){
			const that = this

			let formDatas = new FormData();

			this.imgFiles.forEach((i,index)=>{
				formDatas.append("files", i);
			});

			Toast.loading({
				message: '保存中...',
				forbidClick: true,
				overlay:true,
				duration:0
			});

			axios({
				url:`${BaseApiUrl}/Img/InsertFtpImage`,
				method: "post",
				data: formDatas,
				headers: { "Content-Type": "multipart/form-data"}
			}).then(res=>{
				Toast.clear()
				if(res.data.status === 200 && res.data.success){
					this.saveImgUrlArr.push(...res.data.response)
					this.imgFiles = []
				}else{
					Toast.fail(res.data.msg);
				}
			})
		},

		clearSku(i,i2){
			this.$set(this.info3[i].boxDetail[i2],'shipmentID','')
			this.$set(this.info3[i].boxDetail[i2],'supplierCode','')
			this.$set(this.info3[i].boxDetail[i2],'shippingPlanDetailID','')
		},

		inputLenChange(name, i, field, fix = 1){
			let s = this[name][i][field]
			if(s.includes('.')){
				const m = s.split('.')[0]
				if(m.length > 3){
					this.$set(this[name][i], field, Number(`${m.slice(0,3)}.${m[1]}`))
				}
			}else{
				if(s.length > 3){
					this.$set(this[name][i], field, this[name][i][field].slice(0,3))
				}
			}
		},

		inputNumChange(name, i, field, fix = 1) {

			function toF(n, fix) {
				return Number(n).toFixed(fix)
			}

			let s = this[name][i][field]

			let num = toF(s, fix)
			if (num < 0) {
				Toast('请输入正数')
				num = toF(0, fix)
			}
			this.$set(this[name][i], field, num)
		},

		inputParseIntNumChange(name,i,field) {
			let num = Number(this[name][i][field])
			if (num < 0) {
				Toast('请输入正整数')
				num = Math.abs(num)
			}
			this.$set(this[name][i], field, parseInt(num))
			
			if(field === 'singleBoxQty'){
				this.$set(this[name][i],'inStockSKUCode',this[name][i].singleBoxQty ? `${this[name][i].sku}-N${this[name][i].singleBoxQty}`:'')
			}

			if(name === 'info1' && field === 'boxCount'){
				if(String(this.info1[i].boxCount).length>10) this.$set(this.info1[i],'boxCount',Number(String(this.info1[i].boxCount).slice(0,10)))
			}
		},
	},
}
</script>

<style lang="less" scoped>
@import "../../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    padding-left: 18.5%;
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;
      &>div {
        flex: 1;
        line-height: 25px;
		max-width: 100%;
        display: flex;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
@media (max-width:450px) {
  .item-info{
    font-size: 12px;
    .item-ul {
      padding: 0 2%;
      .item-li {
        .item-right{
          margin-left: 3%;
        }
        & > div {
          line-height: 22px;
          & > span {
            &:first-child {
              padding-right: 6px;
            }
            &:last-child{
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.conventionalBox-info {
	font-size: 14px;
	.signInDetail-btnBox {
		background-color: #fbf9fe;
		padding: 10px;
		border-bottom: 1px solid #cccccc;
		li {
			line-height: 40px;
			white-space: nowrap;
			display: flex;
			align-items: baseline;
		}
		.volume {
			min-width: 10%;
			max-width: 27%;
			height: 22px;
			line-height: 22px;
			font-size: 12px;
			border: 0;
			background-color: #fbf9fe;
			border-bottom: 1px solid #757474;
			outline: none;
			margin: 0 5px;
			padding: 0 5px;
			box-sizing: border-box;
		}
		&:last-child{
			border-bottom: 0;
		}
	}
}
.sign-photo-box {
	margin: 5px 10px 10px;
	box-sizing: border-box;
	padding: 10px;
	ul {
		.sign-photo-item {
			width: 30.333%;
			height: 100px;
			border: 5px solid #ccc;
			box-sizing: border-box;
			position: relative;
			float: left;
			margin: 0 4.5% 4.5% 0;
			line-height: 127px;
			overflow: hidden;
			box-shadow: 0px 0px 7px -1px #cccccc;
			&:nth-child(3n) {
				margin-right: 0;
			}
            .delete-icon {
                position: absolute;
                background: red;
                color: #fff;
                width: 16px;
                height: 16px;
                top: 0px;
                right: 0px;
                line-height: 16px;
                font-size: 12px;
                border-radius: 16px;
                text-align: center;
            }
			.sign-photo-item-img{
				width: auto;
				height: 100%;
			}
		}
		.sign-photo-btn {
			display: inline-block;
			vertical-align: top;
			width: 30.333%;
			.photo {
				height: 100px;
				background-color: #faf9fc;
				position: relative;
			    box-shadow: 0px 0px 7px -1px #cccccc;
				p {
					border: 1px dashed #ccc;
					padding: 10px;
					width: 50px;
					height: 50px;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					margin: 0;
					i {
						font-size: 40px;
						color: #ccc;
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
		}
	}
}
.sign-photo-save {
	padding: 0 10px;
}
.photo{
    font-size: 14px;
}
.submit-btn {
	width: 100%;
	height: 40px;
	border-radius: 5px;
	background-color: #169bd5;
	color: #fff;
	font-size: 18px;
	border: 0;
}
.hidden {
	display: none;
}
.addInfo,.delInfo{
    right: 1%;
    color: #027db4;
}
.delInfo{    
	right: 13%;
    color: #da2727;
}
.p-title{
    font-weight: 600;
    margin-bottom: 0;
    padding-left: 10px;
    font-size: 14px;
}
.btn-other{
    height: 36px !important;
    min-width: 48% !important;
}
.add{
    border: 2px dashed #ccc;
    width: 100%;
    text-align: center;
    line-height: 15px;
    color: #ccc;
    margin: 5px 0;
}
.add:hover{
    border-color: rgb(151, 151, 151);
    color: rgb(151, 151, 151);
}
.btnBox-left{
    width: 100%;padding-right: 5px;
}
.btnBox-right{
    width: 100%;padding-left: 5px;
}
.tips{
	position: absolute;
    left: -50px;
    top: 33px;
    font-size: 12px;
    line-height: 20px;
}
.vm {
	vertical-align: middle;
}
</style>